<template>
  <div v-if="this.flashMessage" class="flash-container">
    <div class="row flash-message">
      <div class="col-md-8 col-md-offset-2">
        <div class="panel flash-shadow" :class="'panel-' + this.flashMessage.type">
          <div class="panel-heading" v-if="this.flashMessage.title">
            <a v-if="closable" href="#" class="close" aria-label="close" v-on:click="hide_message">&times;</a>
            <h4 class="panel-title">{{ this.flashMessage.title }}</h4>
          </div>
          <div class="panel-body">
            {{ this.flashMessage.body }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['flashMessage']),
  },
  data() {
    return {
      closable: true,
      timer: undefined,
    };
  },
  methods: {
    hide_message() {
      if (this.timer !== undefined) {
        clearTimeout(this.timer);
        this.timer = undefined;
      }
      this.$store.commit('HIDE_FLASH');
    },
  },
  watch: {
    flash_message(newFlashMessage) {
      if (newFlashMessage !== undefined) {
        if (newFlashMessage.duration > 0) {
          this.timer = setTimeout(this.hide_message, newFlashMessage.duration * 1000);
          this.closable = false;
        }
      }
    },
  },
};
</script>

<style>
.flash-container {
  position: absolute;
  z-index: 999;
  top: 200px;
  left: 15px;
  bottom: 0;
  right: 0;
  height: 100px;
}

.flash-message {
  width: 100%;
}

.flash-message h4 {
  font-size: 20px;
  font-weight: 600;
}

.flash-shadow {
  background-color: rgb(221, 221, 221);
  border-width: 10px;
  border-style: solid;
  border-color: rgb(255, 255, 255);
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  padding: 0px !important;
}
</style>
